import classes from './AppBanner.module.css';

const BANNER_LINK = 'https://www.bookmyrajshree.com/downloadapp?platform=MYRAJSHREE';
const BANNER_PATH = process.env.PUBLIC_URL + '/images/banners/';

const AppBanner = () => {
  return (
    <a
      href={BANNER_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.banner}
      aria-label="Rajshree 399 Diwali Bumper - Download the app"
    >
      <picture>
        <source
          media="(max-width: 767px)"
          srcSet={`${BANNER_PATH}diwali_bumper_320x100.png 1x, ${BANNER_PATH}diwali_bumper_640x200.png 2x`}
        />
        <img
          src={BANNER_PATH + 'diwali_bumper_2400x300.jpg'}
          alt="Rajshree 399 Diwali Bumper - ₹4 Crores Guaranteed Prize On Participation"
          className={classes.banner_img}
        />
      </picture>
    </a>
  );
};

export default AppBanner;
